import { c as _c } from "react/compiler-runtime";
import type { GetHistoryEntry } from '@repo/schema/history';
import { cn } from '@repo/ui/lib/utils';
import { HistoryAvatar } from './history-avatar.tsx';
type ActionCellProps = {
  className?: string;
  entry: GetHistoryEntry;
  title: string;
};
export const ActionCell = t0 => {
  const $ = _c(15);
  const {
    className,
    entry,
    title
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex min-w-0 items-center gap-2 text-base leading-6 break-words", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== entry) {
    t2 = <HistoryAvatar entry={entry} data-sentry-element="HistoryAvatar" data-sentry-source-file="history-action-cell.tsx" />;
    $[2] = entry;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== title) {
    t3 = <div className="font-bold">{title}</div>;
    $[4] = title;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== entry.category_label) {
    t4 = <div>{entry.category_label}</div>;
    $[6] = entry.category_label;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className="min-w-0">{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t1 || $[12] !== t2 || $[13] !== t5) {
    t6 = <div className={t1} data-sentry-component="ActionCell" data-sentry-source-file="history-action-cell.tsx">{t2}{t5}</div>;
    $[11] = t1;
    $[12] = t2;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};